import { useContext } from "react";
import { EmailTemplateContext } from "../EmailTemplateContext";
import { ButtonElement } from "../elements/ButtonElement";
import { Mailtext } from "../elements/Mailtext";
import { Plaintext } from "../elements/Plaintext";

export const InvitationInstructions = () => {
  const ctx = useContext(EmailTemplateContext);

  if (!ctx) return null;

  const {
    data,
    template: { template },
  } = ctx;

  return (
    <>
      <Plaintext template={template[1]!} innerRef={data.current[1]} />
      <ButtonElement template={template[2]!} innerRef={data.current[2]} />
      <Plaintext template={template[3]!} innerRef={data.current[3]} />
      {template[4]?.text && <Plaintext template={template[4]} innerRef={data.current[4]} />}
      <Mailtext template={template[5]!} innerRef={data.current[5]} />
      <Plaintext template={template[6]!} innerRef={data.current[6]} />
      <Plaintext template={template[7]!} innerRef={data.current[7]} />
    </>
  );
};
